import React from 'react';
import { useState, useEffect } from "react";
import { useNavigate, Link, useParams} from "react-router-dom";

import logoNovo from '../../assets/images/logoNovo.png';
import { SweetAlertSuccess, SweetAlertError } from '../../components/sweetAlert/swetAlert.jsx';
import apiAdm from '../../services/apiAdm';
import { isExpired, decodeToken } from "react-jwt";
import md5 from 'md5';

function CriarSenha() {

    const [senha1, setSenha1] = useState('');
    const [senha2, setSenha2] = useState('');

    const navigate = useNavigate();
    const params = useParams();

    const token = params.id;

    return <>
        <div className="main-wrapper">
            <div className="page-wrapper full-page">
                <div className="page-content d-flex align-items-center justify-content-center">
                    <div className="card">
                        <div className="row">
                            <div className="col-md-12 ps-md-1">
                                <div className="auth-form-wrapper px-6 py-5">
                                    <div className="row">
                                        <span className="img-container">
                                            <img src={logoNovo} style={{ marginLeft: 130 }} width={150} height={45} />
                                        </span>
                                    </div>
                                    <br /><br></br>
                                    <div className="row">
                                        <a href="#" className="noble-ui-logo d-block mb-2">Criar senha</a>
                                        <form className="forms-sample">
                                            <div className="mb-3">
                                                <label for="userEmail" className="form-label">Nova senha</label>
                                                <input type="password" className="form-control" onChange={(e) => setSenha1(e.target.value)} value={senha1} />
                                            </div>
                                            <div className="mb-3">
                                                <label for="userEmail" className="form-label">Confirme a senha</label>
                                                <input type="password" className="form-control" onChange={(e) => setSenha2(e.target.value)} value={senha2} />
                                            </div>
                                            <br />
                                            <div>
                                                <button onClick={salvar} className="btn btn-primary w-100 text-white" type="button">Salvar</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>;

    function salvar() {
        const myDecodedToken = decodeToken(token);
        const isMyTokenExpired = isExpired(token);
        if(isMyTokenExpired){
            SweetAlertError({ texto: 'Tempo expirado para criar uma nova senha, por favor solicite novamente.' });
            navigate("/esqueciSenha");
            return;
        }
        if (senha1 == '') {
            SweetAlertError({ texto: 'Falta informar a nova senha.' });
            return;
        };
        if (senha2 == '') {
            SweetAlertError({ texto: 'Falta confirmar a nova senha.' });
            return;
        };
        if (senha1 !== senha2) {
            SweetAlertError({ texto: 'As senhas estão diferentes' });
            return;
        };

        const json = {
            senha: md5(senha1),
        };

        //Verificart se o usuario existe
        apiAdm.get('/usuario/'+myDecodedToken.id)
            .then((resp) => {
                console.log(resp);
                if(resp.data.data.login === myDecodedToken.login){
                    apiAdm.put('/usuario/'+myDecodedToken.id, json)
                        .then((resp) => {
                            console.log(resp);
                            SweetAlertSuccess({texto: 'Senha criada com sucesso.'});
                            navigate("/login");
                        })
                        .catch((erro) => {
                            console.log(erro);
                            SweetAlertError({ texto: 'Falha ao criar a nova senha.' });
                            return;
                        });
                } else {
                    SweetAlertSuccess({texto: 'Falha na autenticação do usuário.'}); 
                }
         })
        .catch((erro) => {
            console.log(erro);
            SweetAlertError({ texto: 'Falha ao verificar o usuário.' });
            return;
        });




    };


};

export default CriarSenha;
